{
  "name": "visa-pay-city",
  "version": "16.2.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o",
    "build": "ng build -c development",
    "build:prod": "ng build -c production",
    "build:preview": "ng build -c preview",
    "build:both": "npm run build && npm run build:prod",
    "archive": "zip -r archive.zip . -x 'node_modules/*' '.angular/*' '.vscode/*'",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "prepare": "husky install"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~20.3.26",
    "@angular/common": "~20.3.26",
    "@angular/compiler": "~20.3.26",
    "@angular/core": "~20.3.26",
    "@angular/forms": "~20.3.26",
    "@angular/platform-browser": "~20.3.26",
    "@angular/platform-browser-dynamic": "~20.3.26",
    "@angular/router": "~20.3.26",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@pixi/unsafe-eval": "^7.4.3",
    "@tweenjs/tween.js": "^23.1.1",
    "angular-google-tag-manager": "1.12.0",
    "bootstrap": "~4.6.0",
    "fontfaceobserver": "^2.3.0",
    "ngx-device-detector": "10.1.0",
    "ngx-pagination": "^6.0.3",
    "pixi-viewport": "5.0.2",
    "pixi.js": "^7.4.0",
    "rxjs": "~7.8.0",
    "stats.js": "^0.17.0",
    "swiper": "^14.0.6",
    "tslib": "^2.4.0",
    "tweakpane": "^4.0.1",
    "xmlbuilder": "^15.1.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.32",
    "@angular/cli": "~20.3.32",
    "@angular/compiler-cli": "~20.3.26",
    "@angular/language-service": "~20.3.26",
    "@tweakpane/core": "^2.0.1",
    "@types/jasmine": "~4.3.5",
    "@types/node": "^18.17.5",
    "@types/three": "^0.155.0",
    "@types/webgl2": "0.0.7",
    "husky": "^8.0.3",
    "jasmine-core": "~4.6.0",
    "lint-staged": "^15.0.2",
    "prettier": "^2.0.0",
    "pretty-quick": "^3.1.3",
    "typescript": "~5.8.3"
  },
  "lint-staged": {
    "**/*": "prettier --write --ignore-unknown"
  },
  "overrides": {
    "qs": ">=6.15.3",
    "glob": ">=12.0.0",
    "tar": ">=7.5.16",
    "pacote": "^21.5.1",
    "micromatch": {
      "picomatch": ">=2.3.2"
    },
    "pretty-quick": {
      "picomatch": ">=3.0.2"
    }
  }
}
